export default __webpack_public_path__ + "static/media/1-2.956566c3.PNG";